import { api } from "../configs/apiConfig";

const AuditorAssignmentService = {
    // Get all auditor assignments
    getAll: async () => {
        try {
            const response = await api.get("/auditorassignment");
            return response.data;
        } catch (error) {
            console.error("Error fetching auditor assignments:", error);
            throw error;
        }
    },

    // Get auditor assignment by ID
    getById: async (id) => {
        try {
            const response = await api.get(`/auditorassignment/${id}`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching auditor assignment ${id}:`, error);
            throw error;
        }
    },

    // Create new auditor assignment
    create: async (auditorAssignmentDTO) => {
        try {
            const response = await api.post("/auditorassignment", auditorAssignmentDTO);
            return response.data;
        } catch (error) {
            console.error("Error creating auditor assignment:", error);
            throw error;
        }
    },

    // Update auditor assignment
    update: async (id, updateDTO) => {
        try {
            const response = await api.put(`/auditorassignment/${id}`, updateDTO);
            return response.data;
        } catch (error) {
            console.error(`Error updating auditor assignment ${id}:`, error);
            throw error;
        }
    },

    // Delete auditor assignment
    delete: async (id) => {
        try {
            const response = await api.delete(`/auditorassignment/${id}`);
            return response.data;
        } catch (error) {
            console.error(`Error deleting auditor assignment ${id}:`, error);
            throw error;
        }
    },

    // Get assignments by workflow
    getByWorkflow: async (workflowId) => {
        try {
            const response = await api.get(`/auditorassignment/by-workflow/${workflowId}`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching auditor assignments for workflow ${workflowId}:`, error);
            throw error;
        }
    },

    // Get assignments by user
    getByUser: async (userId) => {
        try {
            const response = await api.get(`/auditorassignment/by-user/${userId}`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching auditor assignments for user ${userId}:`, error);
            throw error;
        }
    },

    // Get assignments by organizational unit (includes nested)
    getByOrgUnit: async (orgUnitId) => {
        try {
            const response = await api.get(`/auditorassignment/by-orgunit/${orgUnitId}`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching auditor assignments for org unit ${orgUnitId}:`, error);
            throw error;
        }
    },

    // Get hierarchy for UI - ProcessTypes with Workflows and EntityTypes
    getHierarchy: async () => {
        try {
            const response = await api.get("/auditorassignment/hierarchy");
            return response.data;
        } catch (error) {
            console.error("Error fetching auditor assignment hierarchy:", error);
            throw error;
        }
    },

    // Check if user can access workflow
    canAccessWorkflow: async (userId, workflowId) => {
        try {
            const response = await api.get(`/auditorassignment/can-access`, {
                params: {
                    userId,
                    workflowId
                }
            });
            return response.data;
        } catch (error) {
            console.error(`Error checking access for user ${userId} to workflow ${workflowId}:`, error);
            throw error;
        }
    }
};

export default AuditorAssignmentService;
